import { useEffect, useState } from "react";

import { ArrowButton, Button, IconWrapper, Tooltip } from "@king-ict/eupisi-ui/components";
import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getProgramByName } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { ProgramCodeBook, ProgramType } from "../../models/Program";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { codebookRouteProgramName } from '../../routes/routes';
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookProgramNameDetail(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();

  const [programName, setProgramName] = useState<ProgramCodeBook>((location.state as any).programName);
  const userCanEditData = userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager 
    || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk);

  useEffect(() => {
    const fetchProgramName = async () => {
      if (programName && !programName.code) {
        var results = await getProgramByName({ id: programName.id, name: programName.name });

        setProgramName(results);
      }
    }
    fetchProgramName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigateToProgramName = () => {
    history.push(
      codebookRouteProgramName()
    );
  };

  const navigateToEditRecord = () => {
    history.push(
      codebookRouteProgramName(),
      {
        page: "edit",
        programName: programName
      }
    );
  };

  const showEditButton = (): boolean => {

    if (userCanEditData && (programName && (programName.programTypeId === ProgramType.TrainingPrograms ||
      programName.programTypeId === ProgramType.CraftsAndArtsTrainingPrograms ||
      programName.programTypeId === ProgramType.CraftsSpecializationPrograms ||
      programName.programTypeId === ProgramType.RefinementPrograms ||      
      programName.programTypeId === ProgramType.NewVocationalCurriculum))) {
      return true;
    }
    return false;
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <ArrowButton
            backwards
            ariaLabel=""
            onClick={navigateToProgramName}
          />
          <span className={styles.backButtonCaption}>
            {t("codeBook.navigateToCodeBook")}
          </span>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={8}>
          <h3 className={styles.titleWithTooltip}>{t("codeBook.programName")}</h3>
          <Tooltip
            overlay={<div className={styles.tooltipWindow}>{t("codeBook.programNames.note")}</div>}
            placement="right"
          >
            <IconWrapper color="primary">
              <InfoIcon />
            </IconWrapper>
          </Tooltip>
        </Col>
        {showEditButton() &&
          <Col md={4} className="d-flex justify-content-end align-items-center">
            <Button onClick={navigateToEditRecord} >
              {t("common.edit")}
            </Button>
          </Col>
        }
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("codeBook.programCode")}
            value={programName.code}
          />
        </Col>
        <Col md={8} className="mt-5">
          <StaticField
            label={t("codeBook.programName")}
            value={programName.name}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("codeBook.programType")}
            value={programName.programTypeName}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("codeBook.qualification")}
            value={programName.qualificationType!}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("request.hkoLevel")}
            value={programName.hkoLevelName}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("common.educationSector")}
            value={programName.educationSectorName}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("common.educationSubSector")}
            value={programName.educationSubSectorName}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("common.professionField")}
            value={programName.professionFieldName}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("codeBook.professionName")}
            value={programName.professionName}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("common.dateTo")}
            value={programName.dateTo ? hrDate(programName.dateTo) : ""}
          />
        </Col>
      </Row>
    </>
  );
}